import {Component, Input, OnInit} from '@angular/core';
import {FormBuilder, FormGroup, Validators} from '@angular/forms';
import {NgbActiveModal} from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'app-memory-year',
  templateUrl: './memory-year.component.html',
  styleUrls: ['./memory-year.component.scss']
})
export class MemoryYearComponent implements OnInit {
  @Input() memory;
  formMemory: FormGroup;
  // File variables
  img64: string | ArrayBuffer;
  pdf64: string | ArrayBuffer;
  pdfName: string = null;
  messages: any[] = [];
  pdfAttached: string;

  constructor(private fb: FormBuilder, public modal: NgbActiveModal) {
  }

  ngOnInit(): void {
    this.formMemory = this.fb.group({
      id: [(this.memory ? this.memory.id : null)],
      img: [(this.memory ? this.memory.img : ''), [Validators.required]],
      img64: [(this.memory ? this.memory.img : null), [Validators.required]],
      img64Upload: [false],
      name: [(this.memory ? this.memory.name : null), [Validators.required]],
      pdf: [(this.memory ? this.memory.pdf : ''), [Validators.required]],
      pdf64: [(this.memory ? this.memory.pdf : null), [Validators.required]],
      pdf64Upload: [false],
      codeImg: [2, Validators.required],
      orderId: [(this.memory ? this.memory.orderId : null)]
    });

    if (this.memory) {
      this.formMemory.get('id').setValidators(Validators.required);
      this.pdfAttached = this.formMemory.get('pdf').value;
    }
  }

  image64(event): void {
    const reader = new FileReader();
    reader.readAsDataURL(event.target.files[0]);
    reader.onload = () => {
      const image = new Image();
      image.src = String(reader.result);
      image.onload = () => {
        this.messages['i'] = null;
        this.img64 = image.src;
        this.formMemory.get('img').setValue((event.target.files[0]).name);
        this.formMemory.get('img64').setValue(this.img64.split(',')[1]);
        this.formMemory.get('img64Upload').setValue(true);
      };
    };
    reader.onerror = (error) => {
    };
  }

  file64(event): void {
    const reader = new FileReader();
    reader.readAsDataURL(event.target.files[0]);
    reader.onload = (pdf) => {
      this.messages['p'] = null;
      this.pdf64 = pdf.target.result;
      this.pdfName = event.target.files[0].name;
      this.formMemory.get('pdf').setValue((event.target.files[0]).name);
      if (typeof this.pdf64 === 'string') {
        this.formMemory.get('pdf64').setValue(this.pdf64.split(',')[1]);
      }
      this.formMemory.get('pdf64Upload').setValue(true);
    };
  };

  isValid(): void {
    const dataToSend: any = this.formMemory.value;

    if (!this.memory) {
      delete dataToSend.id;
    }
    this.modal.close(dataToSend);
  }
}
